import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, Typography } from '@arco-design/web-react';

import styles from './group-spec-card.module.less';

export interface ReadonlyCommandEllipsisRowProps {
  /** 行首标签（如「启动命令」） */
  label: string;
  /** 弹窗内展示的完整命令文本 */
  fullText: string;
  /** 弹窗标题（如步骤名、节点组名），默认同 label */
  modalTitle?: string;
}

/** 只读预览：命令单行省略，链接打开弹窗查看完整内容 */
export function ReadonlyCommandEllipsisRow({ label, fullText, modalTitle }: ReadonlyCommandEllipsisRowProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const inlineText = useMemo(() => fullText.replace(/\s*\n+\s*/g, ' ').trim(), [fullText]);

  if (!inlineText || inlineText === '-') {
    return null;
  }

  return (
    <>
      <div className={styles.commandEllipsisRow}>
        <span className={styles.cardSubtitleLabel}>{label}:</span>
        <span className={styles.commandEllipsisText} title={inlineText}>
          {inlineText}
        </span>
        <Typography.Text bold type="primary" className={styles.commandViewLink} onClick={() => setVisible(true)}>
          {t('common:view.command')}
        </Typography.Text>
      </div>
      <Modal
        className={styles.commandViewModal}
        title={modalTitle ?? label}
        visible={visible}
        okText={t('common:close')}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        style={{ width: 720 }}
        unmountOnExit
      >
        <div className={styles.commandModalBody}>
          <pre className={styles.commandModalPre}>{fullText}</pre>
        </div>
      </Modal>
    </>
  );
}
